"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mobileStyles = exports.getImage = exports.adaptiveStyled = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _excluded = ["mobile"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BREAKPOINTS = {
  MOBILE: '480px',
  DESKTOP: '481px'
};
var MOBILE_MEDIA_QUERY = "@media only screen and (max-width:".concat(BREAKPOINTS.MOBILE, ")");
var getImage = exports.getImage = function getImage(relativeUrl) {
  return "https://cdn.yc.level.travel/email/2020/".concat(relativeUrl);
};

/**
 * Стили которые нужно применить для мобильной версии писем
 */
var mobileStyles = exports.mobileStyles = function mobileStyles() {
  return (0, _styledComponents.css)(["@media only screen and (max-width:", "){", ";}"], BREAKPOINTS.MOBILE, _styledComponents.css.apply(void 0, arguments));
};

/**
 * Разделяем стили на общие, мобильные и десктопные
 * @param {object} styles - формата {
 *   color: black, // общий стиль
 *   fontSize: 16px, // шрифт для десктопа
 *   mobile: {
 *     fontSize: 13px, // шрифт для мобилы
 *   }
 * }
 * @returns {object} - формата {
 *   common: { ... },
 *   desktop: { ... },
 *   mobile: { ... }
 * }
 */
var splitStyles = function splitStyles(styles) {
  var mobile = styles.mobile,
    other = (0, _objectWithoutProperties2["default"])(styles, _excluded);

  /* если нет кастомных мобильных стилей возвращаем все стили как есть */
  if (!mobile) {
    return {
      common: styles,
      desktop: {},
      mobile: {}
    };
  }

  /**
   * Делим объект стилей на общие стили, и стили перетираемые мобильными
   * Те стили что перетираются мобильными, считаем стилями только для десктопа
   */
  var desktopOnlyStyles = (0, _pick2["default"])(other, Object.keys(mobile));
  var commonStyles = (0, _omit2["default"])(other, Object.keys(mobile));
  return {
    common: commonStyles,
    desktop: desktopOnlyStyles,
    mobile: mobile
  };
};

/**
 * Создаем компонент на базе styled-components
 * Записываем в inline style общие стили и стили для десктопа
 * Записываем в styled стили которые будут работать если почтоный клиент не вырежет
 * блок <style>
 * Если <style> работает и media query то будут применяться мобильные стили
 * при разрешении меньшем BREAKPOINTS.MOBILE
 * @param {object} styledType - type of styled component, f.e. 'div'
 * @param {object} styles - стили формата {
 *   color: black, // общий стиль
 *   fontSize: 16px, // шрифт для десктопа
 *   mobile: {
 *     fontSize: 13px, // шрифт для мобилы
 *   }
 * }
 * @returns {StyledComponent}
 */
var adaptiveStyled = exports.adaptiveStyled = function adaptiveStyled(styledType, styles) {
  var _splitStyles = splitStyles(styles),
    common = _splitStyles.common,
    desktop = _splitStyles.desktop,
    mobile = _splitStyles.mobile;

  /* Мобильные стили будут применяться только при заданной ширине экрана */
  var mobileOnlyStyles = (0, _mapValues2["default"])(mobile, function (value) {
    return value.concat(' !important');
  });
  var mobileOverrides = {};
  mobileOverrides[MOBILE_MEDIA_QUERY] = mobileOnlyStyles;

  /* эти стили пропишутся как inline и будут работать даже если <style> будет вырезан */
  var fallbackStyles = _objectSpread(_objectSpread({}, common), desktop);
  return _styledComponents["default"][styledType].attrs(function () {
    return {
      style: fallbackStyles
    };
  }).withConfig({
    displayName: "emailUtils",
    componentId: "sc-1413mzv-0"
  })(mobileOverrides);
};